import React from "react";
import { Container } from "react-bootstrap";
import Logo1 from "../../Assets/nia.png";
import Logo2 from "../../Assets/citu.png";
import Logo3 from "../../Assets/bisulogo.png";
import Logo4 from "../../Assets/logo1.png";
import Logo5 from "../../Assets/logo3.png";
import Logo6 from "../../Assets/fm.png";
import "./glass.css"; // <-- adjust path if needed

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#f8f9fa",
        width: "100%",
        minHeight: "150px", // Keeps your original height target but allows wrapping when text is added
        padding: "14px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        // GLASS
        background:
          "linear-gradient(to bottom, rgba(255,255,255,0.18), rgba(255,255,255,0.08))",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        borderBottom: "1px solid rgba(255,255,255,0.18)",
        boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
      }}
    >
      <Container>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            textAlign: "center",
          }}
        >
          {/* Logos */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {[Logo1, Logo2, Logo3, Logo4, Logo5, Logo6].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Logo ${index + 1}`}
                style={{ width: "60px", height: "auto" }}
              />
            ))}
          </div>

          {/* Attribution / Collaboration / Instruction */}
          <div
            style={{
              fontSize: "0.85rem",
              lineHeight: 1.35,
              opacity: 0.95,
              maxWidth: "1100px",
            }}
          >
            <div>
              <strong>Developed by:</strong> ᜉᜈᜈᜎᜒᜃ᜔ᜐᜒᜃᜈ᜔ ᜅ᜔ ᜋᜃᜐ x Full Stack Masters, Computing Society,
              Computer Science Department, Bohol Island State University – Bilar Campus 2025-Present
            </div>
            <div>
              <strong>For instruction:</strong> Data Structures and Algorithms; Information Management; Complexity
              of Algorithms; Web Development and Enterprises; Mobile Development; Intelligent Systems
            </div>
            <div>
              <strong>Academic collaboration:</strong> Cebu Institute of Technology–University (Dissertation work
              of Max Angelo Dapitilla Perin, Doctor in Information Technology 2023-2026)
            </div>
            <div>
              <strong>Extension partner:</strong> National Irrigation Administration Region VII, under ABAG: NIA ×
              BISU–Bilar MOA 2025-2030
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
